var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReverseDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 40,
    height: 30.74,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1664 14H11.0393C10.5557 14 10.1114 14.326 10.0194 14.8006C9.89539 15.4389 10.3833 15.9999 11 15.9999H24.1664C24.2584 15.9999 24.333 15.9253 24.333 15.8333V14.1666C24.333 14.0747 24.2584 14 24.1664 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8814 14.7455L25.5482 11.0789C25.4492 10.9952 25.3105 10.9762 25.1925 11.0309C25.0749 11.0859 24.9995 11.2035 24.9995 11.3335V18.6667C24.9995 18.7967 25.0749 18.9143 25.1925 18.969C25.2375 18.99 25.2852 19 25.3329 19C25.4102 19 25.4868 18.973 25.5482 18.9214L29.8814 15.2548C29.9564 15.1911 29.9994 15.0981 29.9994 15.0001C29.9994 14.9022 29.9564 14.8092 29.8814 14.7455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8069 19.0309C14.6889 18.9762 14.5502 18.9952 14.4512 19.0789L10.118 22.7455C10.043 22.8088 10 22.9018 10 22.9998C10 23.0978 10.043 23.1908 10.118 23.2544L14.4512 26.921C14.5125 26.9727 14.5892 26.9997 14.6666 26.9997C14.7142 26.9997 14.7619 26.9897 14.8069 26.9687C14.9246 26.914 14.9999 26.7963 14.9999 26.6663V19.3332C14.9999 19.2032 14.9246 19.0855 14.8069 19.0309Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9802 22.8016C29.8878 22.327 29.4435 22.001 28.9602 22.001H15.8332C15.7412 22.001 15.6665 22.0756 15.6665 22.1677V23.8343C15.6665 23.9263 15.7412 24.001 15.8332 24.001H28.9995C29.6162 24.0009 30.1042 23.44 29.9802 22.8016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseDirection);
export default __webpack_public_path__ + "static/media/reverse-direction.c38e82e07817ea78a824437dbf97778a.svg";
export { ForwardRef as ReactComponent };